<p>item-sales-summary-by-customer works!</p>
